<!--
  创建时间：2023/7/28 10:21
  创建人：toyehuang
  文件描述：HeadNav
-->
<template>
  <div class="layout-head-nav">
    <el-menu
      :default-active="activeMenu.path"
      background-color="#444"
      text-color="#fff"
      active-text-color="#fff"
      :unique-opened="true"
      mode="horizontal"
      class="f-b-c def-w"
    >
      <nav-item
        v-for="route in menus"
        :key="route.id"
        :active-index="activeMenu.path"
        :item="route"
        :base-path="route.path"
      />
    </el-menu>
  </div>
</template>

<script>
import NavItem from "@/layout/components/LayoutHead/HeadNav/NavItem.vue";
import { mapGetters } from "vuex";
export default {
  name: "HeadNav",
  components: { NavItem },
  props: {},
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["menus", "activeMenu"])
  },
  watch: {
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {}
};
</script>

<style scoped lang="scss">
::v-deep{
  .el-scrollbar__wrap{
    overflow-y: hidden;
    overflow-x: hidden;
    width: 100%;
    margin: 0 !important;
  }
}
.layout-head-nav {
  width: 100%;
	background-color: #444;
}
</style>
